<template>
    <div class="container">
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <div class="content c-top">
            <div style="display: flex;align-items: center;">
                <div style="font-weight: bold;font-size: 18px;color: #303033;">页面装修</div>
                <div style="margin-left: 8px;margin-right: 8px;">/</div>
                <div class="bread-small" style="margin-top: -16px;">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item v-for="(item, index) in btns" :index="index.toString()" :key="index">{{ item
                        }}</el-menu-item>
                    </el-menu>
                </div>
            </div>

            <div>
                <popupSetting v-show="activeIndex == 1" ref="popupSet" :activityId="activityId"
                    :activityType="activityType">
                </popupSetting>
                <indexSetting v-show="activeIndex == 0" ref="indexSet" :activityId="activityId"
                    :activityType="activityType">
                </indexSetting>
                <navSetting v-show="activeIndex == 2" ref="navSet" :activityId="activityId" :activityType="activityType">
                </navSetting>
            </div>
            <div class="bottom-box" style="border: none;">
                <div class="bottom-btn" @click="save">保存</div>
            </div>
            <!-- <div class="bottom-box">
                <div class="bottom-btn" @click="saveIndexTemplate">保存</div>
            </div> -->
        </div>

    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import toolBar from '../../../components/toolBar.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
import indexSetting from './components/indexSetting.vue'
import popupSetting from './components/popupSetting.vue'
import navSetting from './components/navSetting.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        toolBar,
        uploadPicture,
        indexSetting,
        popupSetting,
        navSetting
    },
    data() {
        return {
            activityId: null,
            activityType: '',
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '营销活动', path: '/marketingManagement/flashActivity', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '页面装修', path: '', type: '0' },
                ]
            },
            form: {
                id: '',
                name: '',
                orderType: '',
                image: '',
                tag: [],
                tagStore: [],
                tagMarketing: [],
                incomeFlag: '1'
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                ],
                orderType: [
                    { required: true, message: '请输入订单类型', trigger: 'blur' },
                ],
                image: [
                    { required: true, message: '请上传页面图', trigger: 'change' },
                ],
                incomeFlag: [
                    { required: true, message: '', trigger: 'change' },
                ],

            },
            activeIndex: '0',
            btns: ['页面装修', '弹窗装修', '页面导航条'],
            optionsActivity: '新增活动',
            tag: [],
            tagStore: [],
            tagMarketing: [],
            tagIds: [],
            tagIds1: [],
            tagIds2: [],
            tagIdsShow: [],
            tagIdsShow1: [],
            tagIdsShow2: [],
            tagMarketings: [],
            tagMarketingsT: [],
        }
    },
    created() {
        // this.axios.get('/user/userInfo/statistic/' + 25482)
        //     .then(res => {

        //     })
        let type = this.$route.query.type
        this.activityType = type
        if (type == 'add') {
            // this.getTagList()
            // this.getsTagList()
            // this.getmTagList()
            this.optionsActivity = '新增活动'
            this.searchList.list[0].title = '页面装修'
            this.form.name = ''
            this.form.orderType = ''
            this.form.image = ''
            this.tag = []
            this.tagStore = []
            this.tagMarketing = []
            this.form.id = ''
        } else {
            this.optionsActivity = '编辑活动'
            this.searchList.list[0].title = '页面装修'
            this.tag = []
            this.tagStore = []
            this.tagMarketing = []
            this.activityId = Number(this.$route.query.id)
            // this.getDetail(this.$route.query.id)
        }
    },
    beforeDestory() {
        this.$bus.$off('bus-event') // 取消 bus-event 事件
    },
    methods: {
        getImage(val) {
            this.form.image = val
            this.$refs['form'].clearValidate('image')
        },
        save() {
            setTimeout(() => {
                console.log(this.$refs.indexSet.viewData)
                console.log(this.$refs.navSet.navForm)
                // let obj = {
                //     viewData: this.$refs.indexSet.viewData,
                //     navForm: this.$refs.navSet.navForm,
                // }
                // let data = {
                //     activityId: this.activityId,
                //     modelJsonStr: JSON.stringify(this.$refs.indexSet.viewData),
                //     type: '1'
                // }
                // this.axios.post('/indexTemplate/save', data)
                //     .then(res => {
                //         console.log(res)
                //         if (res.code == 0) {
                //             this.getDetail(this.$route.query.id)
                //             this.$message.success('保存成功')
                //         } else {
                //             this.$message.warning(res.message)
                //         }
                //     })
                this.$refs.popupSet.savePopupWindowTemplate(0)
                this.$refs.indexSet.saveIndexTemplate()
                this.$refs.navSet.saveIndexTemplate()
                this.$message.success('保存成功')
            }, 1000)
            return
            this.getDataTag()
            this.getDataSTag()
            this.form.tagMarketing = []
            this.tagMarketings.forEach(item => {
                this.tagMarketing.forEach(itm => {
                    if (item.id == itm) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1
                        }
                        this.form.tagMarketing.push(obj)
                    }
                })
            })
            console.log(this.form.tag)
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.axios.post('/marketActivate/addEdit', this.form)
                        .then(res => {
                            if (res.code == 0) {
                                if (this.optionsActivity == '新增活动') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                this.dialogActivity = false
                                this.activityId = res.data
                                console.log(this.activityId, '8888888')
                                if (this.activityId) {
                                    console.log(this.activityId, '77777777')
                                    setTimeout(() => {
                                        this.$refs.popupSet.savePopupWindowTemplate(0)
                                        this.$refs.indexSet.saveIndexTemplate()
                                    }, 1000)

                                }

                            }

                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            // this.$refs.indexSetting.save()
        },
        getDataTag() {
            let tempArr = []
            this.tagIds1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            let tempArr1 = []
            this.tagIds2.forEach(item => {
                this.tag.forEach(itm => {
                    if (itm == item.id) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1,
                            pid: item.pid,
                            childTags: []
                        }

                        tempArr1.push(obj)
                    }
                })

            })
            console.log(tempArr1)
            tempArr.forEach(item => {
                tempArr1.forEach(itm => {
                    if (itm.pid == item.id) {
                        item.childTags.push(itm)
                    }
                })

            })
            this.form.tag = tempArr
        },
        getDataSTag() {
            let tempArr = []
            this.tagIdsShow1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            let tempArr1 = []
            this.tagIdsShow2.forEach(item => {
                this.tagStore.forEach(itm => {
                    if (itm == item.id) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1,
                            pid: item.pid,
                            childTags: []
                        }

                        tempArr1.push(obj)
                    }
                })

            })
            console.log(tempArr1)
            tempArr.forEach(item => {
                tempArr1.forEach(itm => {
                    if (itm.pid == item.id) {
                        item.childTags.push(itm)
                    }
                })

            })
            this.form.tagStore = tempArr
        },
        handleSelect(index) {
            this.activeIndex = index
            if (this.activityIndex == 0) {
                this.$refs.indexSet.getIndexTemplate()
            } else if (this.activityIndex == 1) {
                this.$refs.popupSet.getIndexTemplate()
            } else {
                this.$refs.navSet.getIndexTemplate()
            }
        },
        async getDetail(id) {
            this.$nextTick(() => {
                this.axios.post('/marketActivate/detail', { id: id })
                    .then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            this.getTagList()
                            this.getsTagList()
                            this.getmTagList()
                            res.data.tag.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tag.push(String(itm.id))
                                        }

                                    })

                                }
                            })

                            res.data.tagStore.forEach(item => {
                                if (item.childTags) {
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.tagStore.push(String(itm.id))
                                            console.log(this.tagStore)
                                        }

                                    })

                                }
                            })
                            res.data.tagMarketing.forEach(item => {
                                if (item.selected == 1) {
                                    this.tagMarketing.push(item.id)
                                }
                            })
                            res.data.incomeFlag = String(res.data.incomeFlag)
                            this.form = res.data

                            this.dialogActivity = true
                        }

                    })
                this.$forceUpdate()
            })

        },
        getmTagList() {
            this.tagMarketingsT = []
            this.tagMarketing = []
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/marketing/pageList', data)
                .then(res => {
                    res.data.list.forEach(item => {
                        if (item.status == 1) {
                            this.tagMarketings.push(item)
                        }
                    })
                    // this.tagMarketings = res.data.list;
                })
            console.log(this.tagMarketings)
        },
        getTagList() {
            this.tagIds = []
            this.axios.post('/tagPool/filter/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIds.push(obj)
                    })
                    this.getSecondTag()
                })
        },
        getSecondTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/filter/pageList', data)
                .then(res => {
                    this.tagIds2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIds.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIds1 = this.tagIds
                })
        },
        getsTagList() {
            this.tagIdsShow = []
            this.axios.post('/tagPool/show/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIdsShow.push(obj)
                    })
                    this.getSecondsTag()
                })
        },
        getSecondsTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000,
            }
            this.axios.post('/tagPool/show/pageList', data)
                .then(res => {
                    this.tagIdsShow2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIdsShow.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIdsShow1 = this.tagIdsShow
                })
        },

    }


}
</script>
<style lang="scss">
.optionC {
    .el-cascader-panel {
        .el-scrollbar:first-child {
            .el-checkbox {
                display: none;
            }
        }
    }
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    font-weight: 700;
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
    color: #2d46ee;
    font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
    color: #2d46ee;
    font-weight: 700;
}
</style>
<style lang="scss" scoped>
.bottom-box {
    width: 100%;
    height: 88px;
    border-top: 1px solid #ebebfa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
}

.bottom-btn {
    width: 184px;
    height: 40px;
    background: #2d46ee;
    border-radius: 3px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #2d46ee;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303033;
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
}

.el-menu--horizontal>.el-menu-item {
    height: 44px;
    line-height: 60px;
    font-size: 16px;
    margin-right: 24px;
    width: 76px;
    text-align: center;
    padding: 0;
}

.p-info {
    width: 345px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909099;
    margin-bottom: 18px
}
</style>